import { HTTPError, ResponseParsed } from "fetch-run";

import { ErrorMapperResult, FormErrors, FormValues, useForm } from "./form";

type ErrorData<T> = Record<keyof T, string[]>;

async function mapServerError<T extends FormValues>(
  error: HTTPError
): Promise<ErrorMapperResult<T>> {
  if (error.response.status === 422) {
    const errorData: ErrorData<T> = await error.response.clone().json();

    const result: FormErrors<T> = {};

    for (const fieldName in errorData) {
      result[fieldName] = errorData[fieldName][0];
    }

    return [result, null];
  }

  return [{}, null];
}

export function useServerForm<T extends FormValues>(
  initialValues: T,
  error: Error | null
) {
  return useForm<T>(initialValues, error, mapServerError);
}

type ServerErrors = Record<string, string[] | string>;

export async function getServerErrorMessage(
  res: ResponseParsed
): Promise<string> {
  const data = (res.data ?? {}) as any; // TOFIX: fetch-run. Type does not allow res.data.message

  if (data?.message) {
    return data.message;
  }

  const errors = (data ?? {}) as ServerErrors;

  const firstError: string | string[] | null = Object.values(errors)[0] ?? null;

  return (
    (Array.isArray(firstError) ? firstError[0] : firstError) ??
    "An error occurred. Please try again"
  );
}
